import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UnifiedPrintComponent } from '../unified-print/unified-print.component';

@Component({
  selector: 'app-consolidated-report-modal',
  templateUrl: './consolidated-report-modal.component.html',
  styleUrls: ['./consolidated-report-modal.component.scss'],
  imports: [UnifiedPrintComponent],
})
export class ConsolidatedReportModalComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<ConsolidatedReportModalComponent>>(MatDialogRef);

  closeModal(ev) {
    this.dialogRef.close(ev);
  }
}
